import { useEffect } from "react";
const useComponentMountHandler = (isMounted) =>
  useEffect(() => {
    isMounted.current = true;
    return () => (isMounted.current = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
export default useComponentMountHandler;
